// @flow

// action types
export const DISPLAY_CONFIRMATION: string = 'DISPLAY_CONFIRMATION';
export const DISMISS_CONFIRMATION: string = 'DISMISS_CONFIRMATION';

// response types
export const RESPONSE_CONFIRMED = 'RESPONSE_CONFIRMED';
export const RESPONSE_CANCELLED = 'RESPONSE_CANCELLED';

// confirmation types
export const CONFIRM_DELETE = 'CONFIRM_DELETE';
export const CONFIRM_DEFAULT = 'CONFIRM_DEFAULT';
